// @flow

import {
  SET_SESSION_ID,
  GET_SESSION_ID_DONE,
  GET_SESSION_ID,
  WS_SET_SESSION_ID_REQUEST,
  WS_SET_SESSION_ID_SUCCESS,
  WS_SET_SESSION_ID_ERROR,
} from '../actions';
import type { SessionState, SessionActions, ApiState } from '../types';

const requestInitialState = (): ApiState<any, any, any> => ({
  loading: false,
  time: null,
  success: false,
  params: null,
  error: null,
  response: null,
});

export const initialState = {
  isFetching: false,
  getSessionId: {},
  setSessionId: requestInitialState(),
};

export const sessionReducer = (state: SessionState = initialState, action: SessionActions) => {
  switch (action.type) {
    case SET_SESSION_ID:
      return {
        ...state,
        isFetching: true,
      };
    case GET_SESSION_ID:
      return {
        ...state,
        isFetching: false,
      };
    case GET_SESSION_ID_DONE:
      return {
        ...state,
        getSessionId: action.payload,
      };
    case WS_SET_SESSION_ID_REQUEST:
      return {
        ...state,
        setSessionId: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };
    case WS_SET_SESSION_ID_SUCCESS:
      return {
        ...state,
        setSessionId: {
          ...state.setSessionId,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };
    case WS_SET_SESSION_ID_ERROR:
      return {
        ...state,
        setSessionId: {
          ...state.setSessionId,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };
    default:
      return state;
  }
};
